import ProductImageCardList from './ProductImageCardList';

export default ProductImageCardList;
